import { render, staticRenderFns } from "./WechatCode.vue?vue&type=template&id=44e1de6d&scoped=true"
import script from "./WechatCode.vue?vue&type=script&lang=js"
export * from "./WechatCode.vue?vue&type=script&lang=js"
import style0 from "./WechatCode.vue?vue&type=style&index=0&id=44e1de6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1de6d",
  null
  
)

export default component.exports